import { t } from "@lingui/core/macro";
import { createNativeStackNavigator } from "@react-navigation/native-stack";

import { PackageDetailScreen } from "@/screens/Profile/screens/PackageDetailScreen";
import { PackageListScreen } from "@/screens/Profile/screens/PackageListScreen";
import { PackageOrderScreen } from "@/screens/Profile/screens/PackageOrderScreen";

export type PackagesStackNavigatorParamList = {
  PackagesList: undefined;
  PackageDetail: { packageId: string };
  PackageOrder: { orderId: string; packageId: string };
};

const Stack = createNativeStackNavigator<PackagesStackNavigatorParamList>();

export const PackagesStackNavigator = () => {
  return (
    <Stack.Navigator
      initialRouteName="PackagesList"
      screenOptions={(screenProps) => ({
        headerShown: false,
      })}
    >
      <Stack.Screen
        name="PackagesList"
        options={{
          title: t`Packages`,
        }}
        component={PackageListScreen}
      />
      <Stack.Screen
        name="PackageDetail"
        options={{
          title: t`Packages`,
        }}
        component={PackageDetailScreen}
      />
      <Stack.Screen
        name="PackageOrder"
        options={{
          title: t`Packages`,
        }}
        component={PackageOrderScreen}
      />
    </Stack.Navigator>
  );
};
